exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blm-number-input[data-v-8c6925ae]{-ms-flex-pack:justify;justify-content:space-between}.blm-number-input[data-v-8c6925ae],.number[data-v-8c6925ae]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;display:-ms-flexbox;display:flex}.number[data-v-8c6925ae]{-ms-flex-align:center;align-items:center;margin:0 5px;text-align:center}.number-control[data-v-8c6925ae]{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:20px;height:20px;border:1px solid #344085;cursor:pointer;background:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:700}.invalid[data-v-8c6925ae]{border-color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c6925ae","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/BlmNumberInput.vue
// module id = 974
// module chunks = 0